import { MessageContentFormatEnum } from "@/lib/enum/templateEnums/messageContentFormat.enum";
import { MessageMedium } from "@/lib/enum/templateEnums/messageMedium.enum";
import { MrfiktivCreateMessageDtoGen, MrfiktivMessageAttachmentGen } from "@/services/mrfiktiv/v1/data-contracts";

export interface IBuildEmailMessageDtoArgs {
  /** All "to" recipients; joined into a semicolon-separated list for the backend. */
  to: string[];
  /** Cc recipients; omitted from the DTO when empty. */
  cc: string[];
  /** Bcc recipients; omitted from the DTO when empty. */
  bcc: string[];
  subject: string;
  body: string;
  attachments?: MrfiktivMessageAttachmentGen[];
}

/**
 * Builds a single email message DTO from the composer inputs. The to/cc/bcc
 * recipients are each sent as one semicolon-separated string (backend-supported),
 * so the composer no longer fans out one message per recipient. Empty cc/bcc are
 * omitted so the backend does not receive empty values.
 */
export function buildEmailMessageDto(args: IBuildEmailMessageDtoArgs): MrfiktivCreateMessageDtoGen {
  return {
    to: args.to.join(";"),
    cc: args.cc.length ? args.cc.join(";") : undefined,
    bcc: args.bcc.length ? args.bcc.join(";") : undefined,
    content: {
      subject: args.subject,
      body: args.body
    },
    attachments: args.attachments,
    meta: {
      contentFormat: MessageContentFormatEnum.HTML,
      medium: MessageMedium.EMAIL
    }
  };
}
